module.exports = __webpack_public_path__ + "img/Speaker=Susan Shu Chang.754356f7.png";